<mat-card *ngFor="let alert of alerts; trackBy: trackByAlertId" class="{{cssClass(alert)}}">
    <a class="close" (click)="removeAlert(alert)">&times;</a>
    <span [innerHTML]="alert.message"></span>
</mat-card>